import { DynamicImagery } from '@pepperhq/menu-sdk';
import React from 'react';
import { MuiModal } from 'ui/MuiModal';
import { EnrichedDynamicImagery, MenuType } from '../model/menu';
import { EnrichedProduct } from '../model/product';
import { DynamicImageryEditForm } from './DynamicImageryEditForm';

interface DynamicImageryEditModalProps {
    open: boolean;
    onClose: () => void;
    onSubmit: (dynamicImagery: DynamicImagery) => void;
    dynamicImagery?: EnrichedDynamicImagery;
    products: EnrichedProduct[];
    menu: MenuType;
    productIdToTitle: Map<string, string>;
}

export const DynamicImageryEditModal: React.FC<DynamicImageryEditModalProps> = ({
    open,
    onClose,
    onSubmit,
    dynamicImagery,
    products,
    menu,
    productIdToTitle
}) => (
    <MuiModal open={open} onClose={onClose} noMaxWidth>
        <DynamicImageryEditForm
            onSubmit={onSubmit}
            dynamicImagery={dynamicImagery}
            products={products}
            menu={menu}
            onClose={onClose}
            productIdToTitle={productIdToTitle}
        />
    </MuiModal>
);
